<template>
  <div>
    <v-row class="pb-4">
      <v-col cols="12">
        <p class="text-h6 gray--text font-weight-bold mb-3">
          MODALIDADES
        </p>
      </v-col>
      <v-col
        v-for="(item, key) of listActiveModality"
        :key="key"
        cols="12"
        sm="5"
        md="3"
        class="pr-5 pb-5 d-flex justify-center justify-sm-start"
      >
        <CardDescriptionButton
          @click="selectedItem(item.modalidade, 'modalidade')"
          :name="item.modalidade.nome"
          :class="{
            'base-card-active': findActiveItem(item.modalidade, 'modalidade')
          }"
        />
      </v-col>
    </v-row>
    <v-divider class="pb-7" />
    <fragment v-if="hasModality">
      <v-row class="pb-4">
        <v-col cols="12">
          <p class="text-h6 gray--text font-weight-bold mb-3">
            SUB-MODALIDADES
          </p>
        </v-col>
        <v-col
          v-for="(item, key) of listActiveSubModality"
          :key="key"
          cols="12"
          sm="5"
          md="3"
          class="pr-5 pb-5 d-flex justify-center justify-sm-start"
        >
          <CardDescriptionButton
            @click="selectedItem(item.submodalidade, 'submodalidade')"
            :name="item.submodalidade.nome"
            :class="{
              'base-card-active': findActiveItem(
                item.submodalidade,
                'submodalidade'
              )
            }"
          />
        </v-col>
      </v-row>
      <v-divider />
    </fragment>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" xl="2" class="pr-sm-5">
          <BaseButton
            v-html="'CANCELAR'"
            class="pink white--text"
            width="100%"
            @click="returnForm"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3" xl="2">
          <BaseButton
            v-html="buttonText"
            class="secondary"
            width="100%"
            @click="submit"
            :disabled="!hasModalityAndSubmodalitySelected"
          />
        </v-col>
      </v-row>
    </BaseFooter>
    <ModalCancelModality
      @close="closeModalCancel"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </div>
</template>
<script>
import _ from "lodash";
import { mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import CardDescriptionButton from "@/components/CardDescriptionButton.vue";
import ModalCancelModality from "../../insurance_company/components/ModalCancelInsurance";
import FormMixin from "@/mixins/FormMixin";
export default {
  components: {
    CardDescriptionButton,
    ModalCancelModality
  },
  mixins: [LoadingRequest, FormMixin],
  data: () => ({
    buttonText: "ADICIONAR",
    modalCancel: false
  }),
  computed: {
    ...mapState("insuranceCompany", ["currentInsuranceCompany"]),
    hasModalityAndSubmodalitySelected() {
      return (
        !_.isEmpty(this.form.modalidade) && !_.isEmpty(this.form.submodalidade)
      );
    },
    listActiveModality() {
      return this.currentInsuranceCompany.modalidades;
    },
    listActiveSubModality() {
      return this.currentInsuranceCompany.modalidades.find(
        x => x.modalidade.id === this.form.modalidade.id
      ).submodalidades;
    },
    hasModality() {
      return !_.isEmpty(this.form.modalidade);
    }
  },
  methods: {
    returnForm() {
      if (this.formIsPristineCommon(this.form, this.cloneForm)) {
        this.$emit("return");
      } else {
        this.modalCancel = true;
      }
    },
    submit() {
      this.$emit("return");
    },
    selectedItem(value, item) {
      this.form[item] = value;
    },
    findActiveItem(value, item) {
      return this.form[item] ? value.id === this.form[item].id : false;
    },
    closeModalCancel(value) {
      this.modalCancel = false;
      this.form.modalidade = _.cloneDeep(this.cloneForm.modalidade);
      this.form.submodalidade = _.cloneDeep(this.cloneForm.submodalidade);
      if (value) this.$emit("return");
    }
  },
  mounted() {
    this.buttonText = this.form.submodalidade.id ? "ALTERAR" : "ADICIONAR";
    this.cloneForm = _.cloneDeep(this.form);
  },
  props: {
    form: {
      type: Object
    }
  }
};
</script>
